import { create } from "zustand";

/**
 * "Customize home" dialog for Admin Home. The gear lives in the app header and
 * the dialog is mounted by the page, so the two share this flag.
 */
export type AdminHomeCustomizeState = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};

export const useAdminHomeCustomizeStore = create<AdminHomeCustomizeState>(
  (set) => ({
    isOpen: false,
    open: () => set({ isOpen: true }),
    close: () => set({ isOpen: false }),
  }),
);
